module.exports = __webpack_public_path__ + "templates.product_available_info-6a1d9a4c.html";